import type { SxProps, Theme } from "@mui/material";
import { MenuItem, TextField } from "@mui/material";
import { useRollApplications } from "../hooks/useRollsBlanks";

interface RollApplicationSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	size?: "small" | "medium";
	required?: boolean;
	error?: boolean;
	helperText?: string;
	includeAll?: boolean;
	disabled?: boolean;
	sx?: SxProps<Theme>;
}

export const RollApplicationSelector = ({
	value,
	onChange,
	label = "Roll Application",
	fullWidth = false,
	size = "small",
	required = false,
	error = false,
	helperText,
	includeAll = false,
	disabled = false,
	sx,
}: RollApplicationSelectorProps) => {
	const { data: applications = [], isLoading } = useRollApplications();

	return (
		<TextField
			select
			label={label}
			value={value ?? ""}
			onChange={(e) =>
				onChange(e.target.value === "" ? null : Number(e.target.value))
			}
			size={size}
			fullWidth={fullWidth}
			required={required}
			disabled={disabled || isLoading}
			error={error}
			helperText={helperText}
			sx={
				{
					minWidth: 180,
					width: fullWidth ? "100%" : undefined,
					...sx,
				} as SxProps<Theme>
			}
			slotProps={{
				select: {
					sx: { width: "100%" },
				},
			}}
		>
			{includeAll && (
				<MenuItem value="">
					<em>All</em>
				</MenuItem>
			)}
			{!includeAll && !required && (
				<MenuItem value="">
					<em>None</em>
				</MenuItem>
			)}
			{applications.map((app) => (
				<MenuItem key={app.Id} value={app.Id}>
					{app.Name}
				</MenuItem>
			))}
		</TextField>
	);
};
